import { ChevronRight, StoreIcon2 } from '@fagmobler/ui';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { useStores } from '@/components/store';
import { useNavigation } from '@/contexts/navigation';
import { ServerProduct } from '@/lib/janitsjar/Product';
import type {
  FagmoblerAlgoliaProduct,
  FagmoblerPublicOmniumProduct,
} from '@fagmobler/types';
import { serverProductToFagmoblerInventory } from '@/cataloguePages/productPageWithVariants/helpers';
import { StorePickerModalKey } from '@/cataloguePages/productPageWithVariants/modals/StorePicker';

type SectionContainerStoreButtonProps = {
  className?: string;
  product: ServerProduct;
  omniumProduct: FagmoblerPublicOmniumProduct;
  algoliaProduct: FagmoblerAlgoliaProduct;
  openModal: (modal: string) => void;
};

export default function SectionContainerStoreButton({
  className,
  omniumProduct,
  algoliaProduct,
  product,
  openModal,
}: SectionContainerStoreButtonProps) {
  const { setShowStoreStock } = useNavigation();
  const { current: currentStoreQuery } = useStores();

  const currentStore = currentStoreQuery.data?.store;

  const currentStoreStock =
    product.stock?.find((s) => s.storeId === currentStore?.id) || null;

  const displayStores = product.stock?.filter((s) => s.display > 0) || [];

  const storeName = currentStore?.name ?? 'Velg butikk';
  const storeLocation = currentStore?.address
    ? `${currentStore?.address?.streetName}, ${currentStore?.address?.zipcode} ${currentStore?.address?.city}`
    : '';

  const inventory = serverProductToFagmoblerInventory(product);

  const handleClick = () => {
    setShowStoreStock({
      visible: true,
      inventory,
      selectedProduct: omniumProduct,
      algoliaProduct,
    });
  };

  return (
    <div className="flex flex-col gap-1">
      <button
        onClick={handleClick}
        className={twMerge(
          clsx('flex items-center justify-between gap-2 group', className)
        )}
      >
        <div className="flex flex-col gap-1 items-start">
          <div className="flex gap-2">
            <StoreIcon2 className="w-5 h-5" />
            <span className="flex-grow text-left hd-base group-hover:underline">
              {storeName}
            </span>
            {currentStoreStock && currentStoreStock.display > 0 ? (
              <span className="body-xs font-normal px-1.5 py-0.5 rounded-full border border-success-50 bg-success-40">
                Utstilt i {storeName.replace('Fagmøbler ', '')}
              </span>
            ) : null}
          </div>
          <span className="body-sm text-neutral-70">{storeLocation}</span>
        </div>
        <ChevronRight className="w-4 h-4" />
      </button>
      {displayStores.length > 0 && (
        <span className="body-xs text-neutral-70">
          Utstilt i:{' '}
          <button
            onClick={() => {
              openModal(StorePickerModalKey);
            }}
            className="body-link-xs"
          >
            {displayStores.length} butikker
          </button>
        </span>
      )}
    </div>
  );
}
